import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  updateOnboardingInfo,
  resetOnboardingInfo,
} from "../../redux/attorneyOnboardingSlice";
import { useNavigate } from "react-router-dom";
import BackIcon from "./assets/backIcon.png";
import NarrowDropdown2 from "../../components/input/new/narrowDropdown2";
import NarrowInputField from "../../components/input/new/narrowInputField";
import AddIcon from "./assets/addIcon.png";
import "./barNumber.css";
import StepFooter from "./stepFooter";

// Example list of US states for the dropdown.
const usaStates = [
  { label: "Alabama", value: "AL" },
  { label: "Alaska", value: "AK" },
  { label: "Arizona", value: "AZ" },
  { label: "Arkansas", value: "AR" },
  { label: "California", value: "CA" },
  { label: "Colorado", value: "CO" },
  { label: "Connecticut", value: "CT" },
  { label: "Delaware", value: "DE" },
  { label: "Florida", value: "FL" },
  { label: "Georgia", value: "GA" },
  { label: "Hawaii", value: "HI" },
  { label: "Idaho", value: "ID" },
  { label: "Illinois", value: "IL" },
  { label: "Indiana", value: "IN" },
  { label: "Iowa", value: "IA" },
  { label: "Kansas", value: "KS" },
  { label: "Kentucky", value: "KY" },
  { label: "Louisiana", value: "LA" },
  { label: "Maine", value: "ME" },
  { label: "Maryland", value: "MD" },
  { label: "Massachusetts", value: "MA" },
  { label: "Michigan", value: "MI" },
  { label: "Minnesota", value: "MN" },
  { label: "Mississippi", value: "MS" },
  { label: "Missouri", value: "MO" },
  { label: "Montana", value: "MT" },
  { label: "Nebraska", value: "NE" },
  { label: "Nevada", value: "NV" },
  { label: "New Hampshire", value: "NH" },
  { label: "New Jersey", value: "NJ" },
  { label: "New Mexico", value: "NM" },
  { label: "New York", value: "NY" },
  { label: "North Carolina", value: "NC" },
  { label: "North Dakota", value: "ND" },
  { label: "Ohio", value: "OH" },
  { label: "Oklahoma", value: "OK" },
  { label: "Oregon", value: "OR" },
  { label: "Pennsylvania", value: "PA" },
  { label: "Rhode Island", value: "RI" },
  { label: "South Carolina", value: "SC" },
  { label: "South Dakota", value: "SD" },
  { label: "Tennessee", value: "TN" },
  { label: "Texas", value: "TX" },
  { label: "Utah", value: "UT" },
  { label: "Vermont", value: "VT" },
  { label: "Virginia", value: "VA" },
  { label: "Washington", value: "WA" },
  { label: "West Virginia", value: "WV" },
  { label: "Wisconsin", value: "WI" },
  { label: "Wyoming", value: "WY" },
];

const BarNumber = () => {
  // Initialize with one blank row
  const [barNumbers, setBarNumbers] = useState([
    { barRegistrationNumber: "", stateOfRegistration: "" },
  ]);

  const userId = useSelector(
    (state) => state.attorneyData.attorneyData?.user_id
  );
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const goBackToProfessionals = () => {
    dispatch(resetOnboardingInfo());
    navigate(`/attorney/${userId}/home`);
  };

  // Handle adding a new blank row
  const handleAddRow = () => {
    setBarNumbers([
      ...barNumbers,
      { barRegistrationNumber: "", stateOfRegistration: "" },
    ]);
  };

  // Handle changes to the input fields
  const handleInputChange = (index, field, value) => {
    const updated = [...barNumbers];
    updated[index][field] = value;
    setBarNumbers(updated);
  };

  // When moving to the next step, pass the final barNumbers to Redux.
  const handleNext = () => {
    dispatch(updateOnboardingInfo({ barRegistrations: barNumbers }));
  };

  // Determine if the StepFooter should be disabled.
  // It will be enabled if at least one row has both a non-empty bar number and state.
  const isFooterDisabled = !barNumbers.some(
    (member) =>
      member.barRegistrationNumber.trim() !== "" &&
      member.stateOfRegistration.trim() !== ""
  );

  return (
    <div className="bar-number-container">
      <div className="category-profile-types">
        <div style={{ display: "flex", flexDirection: "column", width: "40%" }}>
          <div className="category-breadcrumb" onClick={goBackToProfessionals}>
            <img
              src={BackIcon}
              alt="Back Icon"
              style={{ width: "24px", height: "24px" }}
            />
            <a className="category-back-link">Back to professionals</a>
          </div>
          <h1 className="bar-number-title">
            Enter Your Bar Number to Get Started
          </h1>
          <p className="bar-number-subtitle">
            Your bar number is required to confirm your legal practice
            eligibility. If you are licensed in multiple states, please enter
            each bar number so you can accept bookings across different
            jurisdictions.
          </p>
          <p className="bar-number-subtitle2">Bar Number & State</p>
          {barNumbers.map((member, index) => (
            <div key={index} className="bar-number-row">
              <NarrowDropdown2
                title="State Of Practice"
                placeholder="Select"
                items={usaStates}
                isRequired={true}
                value={member.stateOfRegistration}
                onChange={(value) =>
                  handleInputChange(index, "stateOfRegistration", value)
                }
                multiple={false}
              />
              <NarrowInputField
                name="Bar Registration"
                title="Bar Registration Number"
                placeholder="Enter Bar Registration Number"
                isRequired={true}
                value={member.barRegistrationNumber}
                onChange={(e) =>
                  handleInputChange(
                    index,
                    "barRegistrationNumber",
                    e.target.value
                  )
                }
                halfWidth={false}
              />
            </div>
          ))}
          <button className="bar-number-add-button" onClick={handleAddRow}>
            <img
              src={AddIcon}
              style={{ width: "16px", height: "16px" }}
              alt="Add Icon"
            />
            Add another bar number
          </button>
        </div>
      </div>
      <StepFooter
        currentStep={2}
        totalSteps={9}
        location="/attorney/setup/basic-info"
        onNext={handleNext}
        disabled={isFooterDisabled} // Disable the footer if condition is not met
      />
    </div>
  );
};

export default BarNumber;
